import { render } from "./TemporalServiceForm.vue?vue&type=template&id=e38a0da2"
import script from "./TemporalServiceForm.vue?vue&type=script&lang=js"
export * from "./TemporalServiceForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__